import { COMPONENT_UNIT_TYPES } from "src/plugins/shared/item.config";
import { Tag } from "src/plugins/shared/uvitem.config";

const tags: Record<'tags1', Record<string, Tag>> = {
    tags1: {
        light: {
            type: COMPONENT_UNIT_TYPES.Sensor,
            tag: 'light',
            description: 'Light Brigtness (f = [x(Lux) x 1] Lux)',
            display_suffix: 'Lux', 
            config: {
              scale: 1,
              decimal_points: 0
            },
            main_key: null,
            command_key: null,
            can_send_command: false,
            command_v: 'v1',
        },
    },
}

export default tags;